module.exports = __webpack_public_path__ + "img/rsq.b1907d77.svg";